/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/



const validateFullName = (value) => {
  const regex = /^[a-zA-ZáéíóúüñäëïöüÿàèìòùÀÈÌÒÙÁÉÍÓÚÝÄËÏÖÜ\s-]+\s[a-zA-ZáéíóúüñäëïöüÿàèìòùÀÈÌÒÙÁÉÍÓÚÝÄËÏÖÜ\s-]+$/;

  if (value == null) return 'Must enter first and last name.';
  if (regex.test(value.trim())) {
    return true;
  }

  return 'Must enter first and last name.';
};



export default validateFullName;
